import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';
import {ViewMyServicesComponent} from './view-my-services.component';

const routes: Routes = [
  {
    path: '',
    component: ViewMyServicesComponent,
    data: {
      activeLink: ToolbarButton.MY_SERVICES
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewMyServicesRoutingModule { }
